import { Reveal } from "@components/ui";

const cards = [
  {
    title: "Meaningful Impact",
    description:
      "Your work directly contributes to safer communities and high-quality utility services.",
    letter: "M",
    color: "#122d63",
  },
  {
    title: "Career Growth",
    description:
      "Training programs, hands-on experience, and opportunities for internal development.",
    letter: "C",
    color: "#f03813",
  },
  {
    title: "Innovation & Technology",
    description:
      "Exposure to smart metering, energy platforms, and modern utility solutions.",
    letter: "I",
    color: "#1a7a4f",
  },
  {
    title: "People-Centered Culture",
    description:
      "A respectful, multicultural, and supportive working environment.",
    letter: "P",
    color: "#6b4fc7",
  },
  {
    title: "Stability & Compliance",
    description:
      "Backed by Contra Group with long-term UAE operations.",
    letter: "S",
    color: "#d4880f",
  },
  {
    title: "Competitive Benefits",
    description:
      "Market-aligned salaries, medical insurance, paid leave, and performance recognition.",
    letter: "B",
    color: "#0e8a9e",
  },
];

const WhyWorkSection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <Reveal>
          <div className="flex flex-col items-center text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/10 text-[#122d63] text-[14px] md:text-[16px] font-medium tracking-[-0.04em] mb-4">
              Careers
            </span>
            <h2 className="text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63]">
              Why Work at GAZ
            </h2>
            <p className="text-[20px] md:text-[24px] lg:text-[28px] text-[#62636c] tracking-[-0.04em] mt-3 max-w-[700px]">
              Discover the benefits of building your career with us
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, index) => (
            <Reveal key={index} className="h-full">
              <div className="group relative overflow-hidden rounded-[24px] border border-[rgba(98,99,108,0.2)] bg-white p-6 hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] hover:border-[#e8e9ed] transition-all duration-300 h-full">
                {/* Watermark number */}
                <span className="absolute top-3 right-4 text-[80px] font-bold text-[#f1f1f3] leading-none select-none pointer-events-none group-hover:text-[#e8e9ed] transition-colors duration-300">
                  {String(index + 1).padStart(2, "0")}
                </span>

                {/* Icon circle */}
                <div
                  className="relative z-10 w-12 h-12 rounded-full flex items-center justify-center text-white text-[20px] font-semibold mb-5 group-hover:scale-110 transition-transform duration-300"
                  style={{ backgroundColor: card.color }}
                >
                  {card.letter}
                </div>

                <h3 className="relative z-10 text-[20px] md:text-[24px] font-semibold text-[#090d2c] tracking-[-0.04em] mb-2">
                  {card.title}
                </h3>
                <p className="relative z-10 text-[16px] md:text-[20px] text-[rgba(10,14,46,0.75)] tracking-[-0.04em]">
                  {card.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyWorkSection;
